<template>
  <div @click="expand" :class="bgColor" class="py-4 px-3 md:px-6 border-t bg-white transition-colors duration-150 cursor-pointer">
    <div class="flex flex-wrap md:flex-no-wrap items-start">
      <div class="flex-auto md:w-32 lg:w-48 md:flex-none">
        <ul v-if="sammlungList.length" class="text-sm flex flex-wrap md:block md:text-base mb-2">
          <li v-for="tax in sammlungList" :key="tax.id" :class="`text-${tax.slug}`" class="lowercase mr-2 md:mr-0">
            {{ tax.name }}
          </li>
        </ul>
      </div>
      <div class="order-1 md:order-none w-full md:flex-auto md:pr-6">
        <div class="md:flex">
          <div v-if="thumb && thumbnail" class="md:mr-4 md:w-2/5 my-2 md:my-0">
            <img :src="thumbnail.source_url" :width="thumbnail.width" :height="thumbnail.height" :alt="thumb.title.rendered" loading="lazy"/>
          </div>
          <div :class="{ 'md:w-3/5': thumb }">
            <router-link @click.native.stop :to="postLink">
              <h3 :class="titleSize" class="font-bold leading-tight transform-text duration-200" v-html="post.title.rendered"></h3>
            </router-link>
            <p>
              <span>{{ author }}</span><span class="md:hidden">, {{ date }}</span>
            </p>
            <transition @enter="showEl" @leave="hideEl">
              <div v-if="showExcerpt">
                <div v-html="post.excerpt.rendered" class="font-thin my-2"></div>
                <router-link @click.native.stop :to="postLink" tabindex="-1">
                  <span :class="txtColor">&rarr;</span> Weiterlesen
                </router-link>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="hidden md:block w-32 lg:w-48 flex-none font-thin">{{ date }}</div>
      <div :class="txtColor" class="order-0 w-8 lg:w-16 flex-none text-center md:mt-0">
        <div v-if="!featured" @click.stop="expanded = post.id" :class="{ 'rotate-45': expanded }" class="cursor-pointer transform transition-transform duration-150">
          <svg class="inline-block" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z" fill="currentColor"/></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { format } from 'date-fns/esm'
  import { de } from 'date-fns/esm/locale'
  import { relativeUrl } from '@/utils'
  import anime from 'animejs'

  export default {
    name: 'PostRow',
    props: {
      post: Object
    },
    computed: {
      expanded: {
        get () {
          if (this.post && (this.post.acf.featured || this.post.sticky)) {
            return true
          }
          return this.$store.state.expanded === this.post.id
        },
        set (newVal) {
          this.$store.commit('EXPAND', newVal)
        }
      },
      sammlung () {
        if (!this.post) return []
        return this.post._embedded['wp:term'].reduce((a, c) => {
          return a.concat(...c.filter(t => t.taxonomy === 'category'))
        }, [])
      },
      sammlungList () {
        return this.sammlung.filter(t => t.slug !== 'allgemein')
      },
      txtColor () {
        const c = this.sammlung[0]
        if (!c) return
        return `text-${c.slug}`
      },
      bgColor () {
        const c = this.sammlung[0]
        if (!c) return
        if (this.post && this.post.sticky) {
          return `bg-${c.slug}`
        } else {
          return `hover:bg-${c.slug}`
        }
      },
      author () {
        if (!this.post) return
        return this.post.acf.autor || this.post._embedded.author[0]?.name
      },
      date () {
        if (!this.post) return
        const d = new Date(this.post.date)
        return format(d, 'MMM yyyy', { locale: de })
      },
      thumb () {
        if (!this.post) return false
        const featured = this.post._embedded?.['wp:featuredmedia']?.[0]
        return this.post.acf.thumbnail && featured
      },
      thumbnail () {
        return this.thumb.media_details?.sizes.medium
      },
      showExcerpt () {
        return this.expanded
      },
      featured () {
        return this.post && (this.post.acf.featured || this.post.sticky)
      },
      postLink () {
        return relativeUrl(this.post?.link)
      },
      titleSize () {
        return this.expanded ? 'text-2xl' : 'text-xl'
      }
    },
    methods: {
      expand () {
        if (this.expanded) {
          this.$router.push(this.postLink)
        } else {
          this.expanded = this.post.id
        }
      },
      showEl (el, done) {
        const complete = () => {
          el.style.height = 'auto'
          done()
        }
        let t = anime.timeline({ complete })
        const r = el.getBoundingClientRect()
        let h = r.height
        el.style.height = 0
        el.style.opacity = 0
        t.add({
          targets: el,
          height: h,
          duration: 300,
          easing: 'easeInOutQuad'
        }).add({
          targets: el,
          opacity: 1,
          duration: 250,
          easing: 'easeInOutQuad'
        }, '-=200')
      },
      hideEl (el, done) {
        let t = anime.timeline({ complete: done })
        const h = el.getBoundingClientRect().height
        el.style.height = h + 'px'
        t.add({
          targets: el,
          opacity: 0,
          duration: 200,
          easing: 'easeInOutQuad'
        }).add({
          targets: el,
          height: 0,
          duration: 300,
          easing: 'easeInOutQuad'
        }, '-=200')
      }
    }
  }
</script>
